// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RedirectionLoader_wrapper__1LNzR","title":"RedirectionLoader_title__2HVk9","message":"RedirectionLoader_message__3WI2A"};